import { Button, ButtonProps, styled } from "@mui/material";

export const ItemButton = styled(Button)<ButtonProps>(() => ({
  color: "#fff",
  minWidth: "190px",
  backgroundColor: "#1890FF",
  "&:hover": {
    backgroundColor: "#1890FF",
  },
}));